<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container">
<!--      <div class="background-img"><div class="logo-img"></div></div>-->

      <route-view></route-view>
    </div>
  </div>
</template>

<script>
import RouteView from './RouteView'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'UserLayout',
  components: { RouteView },
  mixins: [mixinDevice],
  data () {
    return {}
  },
  mounted () {
    document.body.classList.add('userLayout')
  },
  beforeDestroy () {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>
  #userLayout.user-layout-wrapper {
    height: 100%;

    // &.mobile {
    //   .container {
    //     .main {
    //       max-width: 368px;
    //       width: 98%;
    //     }
    //   }
    // }

    .container {
      width: 100%;
      height: 100%;
      position: relative;

      .background-img {
        background: #f0f2f5  no-repeat left bottom ;
        background-image: url('../views/user/styles/BG.png');
        background-size: cover;
        position: absolute;
        width: 100%;
        height: 100%;

        .logo-img{
          background: no-repeat;
          background-image: url('../views/user/styles/LOGO.png');
          position: absolute;
          width: 90%;
          height: 90%;
          top:2%;
          left:4%;
        }
      }
      a {
        text-decoration: none;
      }

    }
  }
</style>
